import { ScoredCreditCardProduct } from '@mediaingenuity/totallymoney.types'

import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

export enum ProductDetailType {
    GuaranteedCreditLimit = 'GuaranteedCreditLimit',
    GuaranteedExample = 'GuaranteedExample',
}

export interface ContentProps {
    category?: CreditCardProductCategory
    creditCard: ScoredCreditCardProduct
}
